import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import {questionnaireActions, profileActions} from "_actions";
import * as _ from 'lodash';
import {history} from '_helpers/history'
import {Button, Modal, Checkbox} from 'antd';
import "./startCervo.scss";
import "../slider.scss"
import have from "../../../../assets/img/have.png";
import study from "../../../../assets/img/study.png";
import then from "../../../../assets/img/then.png";
import work from "../../../../assets/img/work.png";
import item1 from "../../../../assets/img/caja.png";
import Headerbutton from "../../../../views/admin/component/headerButton.js";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore.js";
import variables from "../../../../_constants/variables.js";
import SliderV from "../../../../components/Slider/SliderV.js";
import {useLocation} from "react-router-dom";


function StartCervoPage(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const [restartQuestions, setRestartQuestions] =  useState(new URLSearchParams(location.search).get('restart') === 'true');
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t, i18n} = useTranslation();
    const [touch, setTouch] = useState(false);
    const [step, setStep] = useState(localStorage.getItem(variables.LASTCERVO) ? +localStorage.getItem(variables.LASTCERVO) : -1);
    const [subStep, setSubStep] = useState(-1);
    const [data, setData] = useState(null);
    const [area, setArea] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [value, setValue] = useState(0)
    const [flips, setFlips] = useState(1);
    const [unsureValue, setUnsureValue] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [currentAvatarStep,setCurrentAvatarStep] = useState();


    function onChange(value) {
        setTouch(true);
        setValue(value)
    }

    var getItemsData = useSelector((state) => state.profileReducer.getItemsData);
    var assestmentsCodeData = useSelector((state) => state.questionnaireReducer.assestmentsCodeData);
    var saveAnswer = useSelector((state) => state.questionnaireReducer.saveAnswer);
    var answersData = useSelector((state) => state.questionnaireReducer.answersData);
    var answersDataError = useSelector((state) => state.questionnaireReducer.answersDataError);
    var deleteAnswerData = useSelector((state) => state.questionnaireReducer.deleteAnswerData);

    useEffect(()=>{

        if (unsureValue){
            setTouch(true);
            setValue(0)
        }else{
            setTouch(false);
            if (value !== 0)
                setTouch(true);
        }
    },[unsureValue])

    useEffect(()=>{
        if(value===999) {
            setUnsureValue(true);
            setValue(-1);
        }
    },[value])

    useEffect(() => {
        if (answersDataError) {
        }
        if (answersData) {
            setAnswers(answersData);
            if (data && data.length) {
                if (answersData.length === data.length && !restartQuestions) {
                    localStorage.removeItem(variables.LASTCERVO);
                    history.push("/admin/end-cervo")
                } else {
                    if (step + 1 === (data.length)) {
                        localStorage.removeItem(variables.LASTCERVO);
                        setStep(0);
                        setValue(0)
                        setTouch(false);
                        setArea(data[0])
                        setStep(0);
                        setSubStep(1);
                    } else {
                        setValue(0)
                        setTouch(false);
                        setArea(data[step + 1])
                        setStep(step + 1);
                        setSubStep(1);
                    }
                }
            }
        }
    }, [answersData, answersDataError])

    const goBack = () => {
        if (step === 0){
            history.push("/admin/cervo-instructions")
        }else{
            setValue(0)
            setTouch(false);
            setArea(data[step - 1])
            setStep(step - 1);
            setSubStep(1);
        }
    }

    useEffect(() => {
        dispatch(questionnaireActions.getAssessmentsCode("CERVO"))
    }, []);


    useEffect(() => {
        if (assestmentsCodeData) {
            let mAgrupado = _.groupBy(assestmentsCodeData, "area_id");
            let mData = []
            Object.keys(mAgrupado).map((key, i) => {
                mData.push(mAgrupado[key][0]);
            });
            setData(mData);
            if (localStorage.getItem(variables.LASTCERVO) && +localStorage.getItem(variables.LASTCERVO) !== -1) {
                const areaData = mData[localStorage.getItem(variables.LASTCERVO)];
                setArea(areaData);
                setStep(+localStorage.getItem(variables.LASTCERVO));
            } else {
                setArea(mData[0])

                setStep(-1);
            }
            setSubStep(1);

            dispatch(questionnaireActions.getAnswers("CERVO"))

        }
    }, [assestmentsCodeData]);

    const Continue = () => {
        setShowModal(false)
        saveResponse(true)
    }

    useEffect(()=>{
    },[area]);

    useEffect(() => {
        if (deleteAnswerData)
         dispatch(questionnaireActions.getAnswers("CERVO"))

    },[deleteAnswerData])

    useEffect(() => {
        let mNext = true;
        if (saveAnswer) {
            dispatch(profileActions.getItems())
            if (area.item) {
                let mSave = true;
                if (getItemsData) {
                    let mData = getItemsData.filter(item => item.item.id === area.item.id);
                    if (mData && mData.length > 0) mSave = false
                }
                if (mSave) {
                    dispatch(profileActions.saveItem({item: area.item.id}))
                    mNext = false;
                }
            }
            const newList = answers.map(ans => {
                if (ans.assessment_id === area.id) {
                    return {...ans, points: value};
                }
                return {...ans};
            });
            let mKk = _.find(answers, {assessment_id: area.id});
            if (mKk)
                mKk.points = value;

            setAnswers(newList);


            if (mNext) dispatch(questionnaireActions.getAnswers("CERVO"))
        }
    }, [saveAnswer])

    useEffect(() => {
        if(data?.length>0 && data[step]?.area?.name!==undefined && step!==0 && data[step]?.area?.name === data[step-1]?.area?.name) {
            setSubStep(2);
            return;
        }
        const interval = setTimeout(() => {
            setFlips(flips + 1);
        }, 800);

        if (flips > 4) {
            clearInterval(interval);
            setSubStep(2);
        }


    }, [flips]);

    useEffect(() => {
        if (subStep === 1 ) {
            setFlips(0);
        } else {
            setFlips(flips+1)
        }
        if (subStep === 2) {
            let mValue = _.filter(answers, function (o) {
                return o.assessment_id === area.id;
            });
            if (mValue && mValue[0]) {
                if(mValue[0].points===999) setUnsureValue(true);
                setValue(mValue[0].points ? mValue[0].points === 999 ? 0 :  mValue[0].points : 0);
                if (mValue[0].points) {
                    setTouch(true)
                } else {
                    setTouch(false)
                }
            }
        }
    }, [subStep])

    const saveResponse = (fromModal=false) => {
        if(!fromModal && area.area.description?.startsWith("CERVO")) {
                dispatch(profileActions.saveItem({groupName: area.area.description}))
                setCurrentAvatarStep(area.area.description);
                setShowModal(true);
                return;
        }
        if (touch) {
            dispatch(questionnaireActions.saveAnswer({
                points: unsureValue?999:value,
                assessment_id: area.id
            }))
            setTouch(false);
            setUnsureValue(false);
        }
        if(step===data.length-1) setRestartQuestions(null);
    }

    const saveAndContinue = () => {
        localStorage.setItem(variables.LASTCERVO, (step -1));
        history.push("/admin/assessment")
    }

    const handleKeyDown = (event) => {
        if ((value === -1 || !touch) && !unsureValue){
        }else {
            if (event.key === 'Enter' ) {
                saveResponse()
            }
        }
    }

    return (
        <div className={"backGroundCervo"}>
            <Modal className={"modalName modal-question modal-question--xs"} title={t(`cervo.${currentAvatarStep}.elemento`)} visible={showModal} onOk={Continue}
                   onCancel={Continue}>
                <div className={"diNombre"}>
                    <div className={"titleInfo"}>
                        {t(`cervo.${currentAvatarStep}.conseguidoagua1`, {nombre: user.name})}
                        <br/>
                        {t(`cervo.${currentAvatarStep}.conseguidoagua2`)}
                    </div>

                    <div className={"elemento"}>
                        <img src={item1}/>
                    </div>

                    <Button style={{marginTop: 20}} type={"primary"} onClick={() => Continue()}
                            className="primaryButton buttonSizeO center-text">{t("continuar")}</Button>

                </div>
            </Modal>
            <div className={"wrapper-question boxed"}>
                <div className={"insideCervo boxed"}>
                    <Headerbutton saveAndContinue={saveAndContinue} title={t("cervo.title")}/>
                </div>
                 {step !== -1 && step !== -2 &&
                    <>

                {subStep === 1 && data && data[step].area && data[step].area.name !== data[step-1]?.area.name &&
                    <div className={"container-portada"/* + (flips % 2 === 0 ? " flipped" : "")*/} onClick={() => setSubStep(2)}>
                        <div className={"content-portada"}>
                            <div className={"content-portada__img backflip"} style={{backgroundImage: `url(/assets/img/p${area.area.image})`}}></div>
                            <h1>{area.area.name}</h1>
                            {/* ToDo : Mostrar frase distinta por area */}
                            {/* Mostrar esta frase si es la puerta de exito */}
                            <h2>{area.area.id===1001&&t("cervo.area.exitof")}</h2>
                            <h2>{area.area.id===1007&&t("cervo.area.emprendemientof")}</h2>
                            <h2>{area.area.id===1012&&t("cervo.area.valorf")}</h2>
                            <h2>{area.area.id===1017&&t("cervo.area.seguridadf")}</h2>
                        </div>
                    </div>
                }
                {subStep === 2 &&
                    <div className={"container-question"}  onKeyDown={handleKeyDown} >
                        <div className={"container-question__auto-margin"}>
                            <div className={"question__header"}>
                                <img className={"question__header-icon"} src={`/assets/img/ri${area.area.image}`}/>
                                <h2>{area.area.like}</h2>
                                <span className={"count"}>{+step + 1}/{data.length}</span>
                            </div>
                            <div className={"question__content"}>
                                <div className={"question__content-mid"}>
                                    <div className={"question__content-mid__info"}>
                                        <div className={"question__content-mid__info-l"}>
                                            {area.area.has &&
                                              <div className={"container-line"}>
                                                  <img className={"container-line__icon"} src={have}/>
                                                  <p className={"container-line__text"}>
                                                      <strong>{t("cervo.have")}</strong>&nbsp;
                                                     {area.area.has}
                                                  </p>
                                              </div>
                                            }
                                            {area.area.then &&
                                              <div className={"container-line"}>
                                                  <img className={"container-line__icon"} src={then}/>
                                                  <p className={"container-line__text"}>
                                                      {t("cervo.then")}&nbsp;
                                                  <strong>{area.area.then}</strong>.
                                                  </p>
                                              </div>
                                            }
                                            {area.area.study &&
                                              <div className={"container-line"}>
                                                  <img className={"container-line__icon"} src={study}/>
                                                  <p className={"container-line__text"}>
                                                      <strong>{t("cervo.make")}</strong>&nbsp;
                                                      {area.area.study}
                                                  </p>
                                              </div>
                                            }
                                            {area.area.work &&
                                              <div className={"container-line"}>
                                                  <img className={"container-line__icon"} src={work}/>
                                                  <p className={"container-line__text"}>
                                                      <strong>{t("cervo.work")}</strong>&nbsp;
                                                      {area.area.work}
                                                  </p>
                                              </div>
                                            }
                                        </div>
                                        <div className={"question__content-mid__info-r"}>
                                            <img className={"illustration"} src={`/assets/img/i${area.area.image}`} width={208} height={208} alt={""}/>
                                        </div>
                                    </div>
                                    <div className={"question__content-mid__question"}>
                                        <p><strong>{t("cervo.interesante")}</strong></p>
                                        <div className={"text-check"}>
                                            <p>{area.question}</p>
                                            <Checkbox style={{color: "white", fontWeight: 500}}
                                                      onChange={(val)=>setUnsureValue(val.target.checked)}
                                                      checked={unsureValue}>
                                                <strong>{t("indeciso")}</strong>
                                            </Checkbox>
                                        </div>

                                        {area.questionType === "RATING" &&

                                          <>
                                              <SliderV
                                                dots={true}
                                                style={{marginTop: 20}}
                                                step={1}
                                                value={value}
                                                onChange={onChange}
                                                min={1}
                                                max={10}
                                                disabled={unsureValue}
                                              />
                                          </>

                                        }
                                        <div className={"content-placeholderrating"}>
                                            <p className="placeholderrating">{t("rechazo")}</p>
                                            <p className="placeholderrating">{t("preferida")}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className={"question__content-bottom"}>
                                    <div className="left">
                                        
                                          <Button onClick={() => goBack()}
                                                  type={"primary"}
                                                  className="btnPrimaryWhite"

                                          >
                                              {t("atras")}
                                          </Button>
                                        
                                    </div>

                                    <div className="right">
                                        <Button onClick={() => saveResponse()}
                                                disabled={(value === -1 || !touch) && !unsureValue}
                                                type={"primary"}
                                                className="primaryButton"
                                        >
                                            {t("continuar")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </>
                }
            </div>
        </div>
    )
}

export default withTranslation()(StartCervoPage);
